import { Component, Inject, OnInit, Pipe, PipeTransform } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-dial-dialog',
  templateUrl: './dial-dialog.component.html',
  styleUrls: ['./dial-dialog.component.scss']
})
export class DialDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { timeChange$?: Subject<string>, time?: string }) { }
  hours: number[] = [];
  minutes: number[] = [];
  selected = 0;
  itemPerCol = 3;
  hourIndex: number = 0;
  minuteIndex: number = 0;
  itemHeight: number = 40;
  //
  position = {
    hours: this.hourIndex ? - (this.hourIndex - 1) * this.itemHeight : 0,
    minutes: this.minuteIndex ? - (this.minuteIndex - 1) * this.itemHeight : 0,
  }
  offset = 0;
  dragging = false;
  previousY = 0;
  ngOnInit(): void {
    this.hours = this.initFillArray(24);
    this.minutes = this.initFillArray(60);
    if (this.data.time) {
      let time = this.data.time.split(':') || [];
      this.position.hours = - (this.hours.findIndex((x) => x === parseInt(time[0])) || 0) * this.itemHeight;
      this.position.minutes = - (this.minutes.findIndex((x) => x === parseInt(time[1])) || 0) * this.itemHeight;
    }
    //
  }

  removeTouch() {

  }

  initFillArray(itemCount: number = 0) {
    return new Array(itemCount).fill(0).map((_, idx) => {
      return idx;
    });
  }

  getProperty(name: string) {
    switch (name) {
      case 'hours': return this.hours;
      default: return this.minutes;
    }
  }

  getStyle(property: string) {
    if (property != 'hours' && property != 'minutes') return;
    let inlineStyle = {
      willChange: 'transform',
      transition: `transform ${Math.abs(this.offset) / 100 + 0.1}s`,
      transform: `translateY(${this.position[property]}px)`
    }
    return inlineStyle;
  }

  start(event: any) {
    this.previousY = event.touches ? event.touches[0].clientY : event.clientY
    this.dragging = true;
  }
  // 
  move(event: any, property: string) {
    if (property != 'hours' && property != 'minutes' || !this.dragging) return;
    let clientY = event.touches ? event.touches[0].clientY : event.clientY
    this.offset = clientY - this.previousY
    let maxPosition = -this.getProperty(property).length * this.itemHeight
    let position = this.position[property] + this.offset
    this.position[property] = Math.max(maxPosition, Math.min(this.itemHeight, position))
    this.previousY = event.touches ? event.touches[0].clientY : event.clientY
  }
  // 
  leave(property: string) {
    if (property != 'hours' && property != 'minutes') return;
    let maxPosition = -(this.getProperty(property).length - 1) * this.itemHeight
    let rounderPosition = Math.round((this.position[property] + this.offset * this.itemPerCol) / this.itemHeight) * this.itemHeight
    let finalPosition = Math.max(maxPosition, Math.min(0, rounderPosition))
    this.dragging = false;
    this.position[property] = finalPosition;
    this.updateValue();
  }

  updateValue() {
    let hourIndex = Math.abs(this.position.hours / this.itemHeight);
    let minuteInex = Math.abs(this.position.minutes / this.itemHeight);
    let time = [this.hours[hourIndex].toString().padStart(2, '0'), this.minutes[minuteInex].toString().padStart(2, '0')].join(':');
    this.data.timeChange$?.next(time);
  }

  goToValue(value: string, property: string) {
    if ((property != 'hours' && property != 'minutes')) return;
    let target = -(this[property].findIndex((x) => x === parseInt(value)) || 0) * this.itemHeight;
    if (this.position[property] === target) {
      this.updateValue();
      this.dialogRef.close();
      return;
    }
    this.position[property] = target;
    this.updateValue();
  }
}

@Pipe({ name: 'padStart' })
export class PadPipe implements PipeTransform {
  transform(value: string | number, length: number) {
    if (value.toString().length == 0) return '';
    return value.toString().padStart(length, '0');
  }
}